export const matchesFirstString = (str = '') => {
  if (!str) return '';

  const matches = str.match(/\b(\w)/g);
  return matches.join('');
};
